import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetLengthOfStayDistributionRequestSchema = z.object({
  facilityId: z.string().optional(),
});

const GetLengthOfStayDistributionResponseSchema = z.object({
  totalResidents: z.number(),
  distribution: z.array(
    z.object({
      range: z.string(),
      minMonths: z.number(),
      maxMonths: z.number().nullable(),
      count: z.number(),
    })
  ),
});

export type GetLengthOfStayDistributionRequest = z.infer<
  typeof _GetLengthOfStayDistributionRequestSchema
>;

export type GetLengthOfStayDistributionResponse = z.infer<
  typeof GetLengthOfStayDistributionResponseSchema
>;

export const getLengthOfStayDistributionById = (
  params: GetLengthOfStayDistributionRequest,
  config?: AxiosRequestConfig<GetLengthOfStayDistributionRequest>
) => {
  return api
    .get('residents/length-of-stay-distribution', {
      params,
      ...config,
    })
    .then(responseContract(GetLengthOfStayDistributionResponseSchema));
};
